import { NOTIFICATION_NAME } from '@/types/notification';
import { PoolStatus, ClientPoolStatus } from '@/types/pool';

export const DOCUMENT_ICON_COLORS = {
  rejection_cancelation: 'text-[#CC4747]',
  documents_uploaded: 'text-[#767676]',
  terms_updated: 'text-[#EED894]',
} as const;

export type NotificationConfig = {
  status?: PoolStatus | ClientPoolStatus;
  showDocumentIcon?: true;
  color?: keyof typeof DOCUMENT_ICON_COLORS;
};

export const NOTIFICATION_TO_POOL_STATUS: Record<NOTIFICATION_NAME, NotificationConfig> = {
  // Borrower notifications
  borrower_pool_created: { status: PoolStatus.SYSTEM_PENDING },
  borrower_pool_approved: { status: PoolStatus.AWAITING_INVESTORS },
  borrower_pool_approved_by_admin: { status: PoolStatus.AWAITING_INVESTORS },
  borrower_pool_rejected_by_admin: { status: PoolStatus.REJECTED },
  borrower_pool_rejected: { status: PoolStatus.REJECTED },
  borrower_offer_received: { status: PoolStatus.OFFER_RECEIVED },
  borrower_counter_offer_received: { status: ClientPoolStatus.COUNTER_OFFER_RECEIVED },
  borrower_pool_canceled: { status: PoolStatus.CANCELED },
  borrower_pool_moved_to_escrow: { status: PoolStatus.IN_ESCROW },
  borrower_pool_funded: { status: PoolStatus.FUNDED },
  borrower_pool_closed: { status: PoolStatus.CLOSED },
  borrower_offer_accepted: {
    status: ClientPoolStatus.BORROWER_OFFER_ACCEPTED,
  },
  borrower_counter_offer_accepted: {
    status: ClientPoolStatus.INVESTOR_COUNTER_OFFER_ACCEPTED,
  },
  borrower_offer_rejected: { showDocumentIcon: true, color: 'rejection_cancelation' },
  borrower_investor_canceled_offer: { showDocumentIcon: true, color: 'rejection_cancelation' },
  borrower_counter_offer_rejected: { showDocumentIcon: true, color: 'rejection_cancelation' },
  borrower_investor_canceled_counter_offer: { showDocumentIcon: true, color: 'rejection_cancelation' },
  borrower_pool_funding_rejected: { status: PoolStatus.FUNDING_REJECTED },

  // Investor notifications
  investor_offer_sent: { status: PoolStatus.OFFER_RECEIVED },
  investor_counter_offer_sent: { status: ClientPoolStatus.COUNTER_OFFER_RECEIVED },
  investor_counter_offer_accepted: { status: ClientPoolStatus.INVESTOR_COUNTER_OFFER_ACCEPTED },
  investor_pool_canceled: { status: PoolStatus.CANCELED },
  investor_pool_moved_to_escrow: { status: PoolStatus.IN_ESCROW },
  investor_pool_funded: { status: PoolStatus.FUNDED },
  investor_pool_closed: { status: PoolStatus.CLOSED },
  investor_offer_accepted: {
    status: ClientPoolStatus.ESCROW_DOCUMENTATION_COMPLETE,
  },
  investor_offer_rejected: { showDocumentIcon: true, color: 'rejection_cancelation' },
  investor_offer_canceled: { showDocumentIcon: true, color: 'rejection_cancelation' },
  investor_counter_offer_rejected: { showDocumentIcon: true, color: 'rejection_cancelation' },
  investor_counter_offer_canceled: { showDocumentIcon: true, color: 'rejection_cancelation' },
  investor_pool_funding_rejected: { status: PoolStatus.FUNDING_REJECTED },
};

export const getNotificationConfig = (notificationName: NOTIFICATION_NAME): NotificationConfig | null => {
  return NOTIFICATION_TO_POOL_STATUS[notificationName] || null;
};
